import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=7cd0979b&scoped=true&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"
import style0 from "./pricehelp.vue?vue&type=style&index=0&id=7cd0979b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd0979b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd0979b')) {
      api.createRecord('7cd0979b', component.options)
    } else {
      api.reload('7cd0979b', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=7cd0979b&scoped=true&", function () {
      api.rerender('7cd0979b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a64SmPAYdL6a/JS/pricehelp.vue"
export default component.exports